"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefundRequestOpenApiOperations = void 0;
/**
 * The OP Refund Request / Approval workflow — desk, 2026-09-12. A separate
 * file from `financial.operations.ts` (that one's own comment calls its 17
 * entries a closed set from Stage 5C.2/5C.3) and from `op-billing.operations.ts`
 * (a different bounded concern), for the same reason each of those is its
 * own file: one array per feature, so an addition never has to touch a
 * catalogue another feature already closed the book on.
 */
exports.RefundRequestOpenApiOperations = [
    {
        operationId: 'findRefundableReceiptByNumber',
        method: 'GET',
        path: '/v1/financial/refund-requests/receipts/by-number',
        summary: 'Find one refundable receipt by its printed number, for the OP Billing Refund screen',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'FindReceiptByNumberQuery',
        responseSchemaRef: 'RefundableReceiptLookup',
        errorCodes: [],
    },
    {
        operationId: 'createRefundRequest',
        method: 'POST',
        path: '/v1/financial/refund-requests',
        summary: 'Submit a refund request — REQUESTED only; moves no money, posts nothing',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'CreateRefundRequestBody',
        responseSchemaRef: 'OpRefundRequest',
        errorCodes: [],
    },
    {
        operationId: 'listMyRefundRequests',
        method: 'GET',
        path: '/v1/financial/refund-requests/mine',
        summary: 'The requester’s own refund requests, any status',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'ListRefundRequestsQuery',
        responseSchemaRef: 'OpRefundRequestList',
        errorCodes: [],
    },
    {
        operationId: 'listPendingRefundRequests',
        method: 'GET',
        path: '/v1/financial/refund-requests/pending',
        summary: 'The approver’s queue — REQUESTED refund requests only',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'EmptyGetRequest',
        responseSchemaRef: 'OpRefundRequestList',
        errorCodes: [],
    },
    {
        operationId: 'listAllRefundRequests',
        method: 'GET',
        path: '/v1/financial/refund-requests',
        summary: 'The shared refund register — every status, for either role',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'ListRefundRequestsQuery',
        responseSchemaRef: 'OpRefundRequestList',
        errorCodes: [],
    },
    {
        operationId: 'getRefundRequestDetail',
        method: 'GET',
        path: '/v1/financial/refund-requests/{id}',
        summary: 'One refund request with freshly computed headroom — the approver’s detail read',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'EmptyGetRequest',
        responseSchemaRef: 'OpRefundRequestDetail',
        errorCodes: [],
    },
    {
        operationId: 'getRefundRequestPrintSlip',
        method: 'GET',
        path: '/v1/financial/refund-requests/{id}/print',
        summary: 'The refund slip for a COMPLETED request — server-built, safe to reprint',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'EmptyGetRequest',
        responseSchemaRef: 'OpRefundSlip',
        errorCodes: [],
    },
    {
        operationId: 'approveRefundRequest',
        method: 'POST',
        path: '/v1/financial/refund-requests/{id}/approve',
        summary: 'Approve & process a refund request — creates the actual FinPayment and REFUND_PROCESSED posting',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'ApproveRefundRequestBody',
        responseSchemaRef: 'OpRefundRequest',
        errorCodes: [],
    },
    {
        operationId: 'rejectRefundRequest',
        method: 'POST',
        path: '/v1/financial/refund-requests/{id}/reject',
        summary: 'Reject a refund request — a reason is required; no payment, no posting',
        version: 'v1',
        tags: ['Refund Request'],
        requestSchemaRef: 'RejectRefundRequestBody',
        responseSchemaRef: 'OpRefundRequest',
        errorCodes: [],
    },
];
//# sourceMappingURL=refund-request.operations.js.map